import { render } from "./InputTag.vue?vue&type=template&id=84e1d668&ts=true"
import script from "./InputTag.vue?vue&type=script&lang=ts"
export * from "./InputTag.vue?vue&type=script&lang=ts"

import "./InputTag.vue?vue&type=style&index=0&id=84e1d668&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__